import { useBreakpointValue, useToken } from '@chakra-ui/react';
import type { BigNumber } from '@ethersproject/bignumber';
import { formatUnits } from '@ethersproject/units';
import { useTranslations } from '@ui/i18n';
import { format } from 'date-fns';
import numbro from 'numbro';

import type { SimpleLineChartProps } from './SimpleLineChart';
import { SimpleLineChart } from './SimpleLineChart';

export type EarningSimpleLineChartProps = Partial<SimpleLineChartProps> & {
  lifeTimeEarnings: { y: BigNumber; date: number }[];
  pendingEarnings: { y: BigNumber; date: number }[];
  tokenName: string;
};
export const EarningSimpleLineChart = ({
  lifeTimeEarnings,
  pendingEarnings,
  tokenName,
  ...props
}: EarningSimpleLineChartProps) => {
  const t = useTranslations();
  const height = useBreakpointValue({ base: 155, desktop: 210 });
  const [mainPinkColor, buttonHoverColor] = useToken('colors', [
    'pink-500',
    'bg-buttonHover',
  ]);
  return (
    <SimpleLineChart
      height={height}
      {...props}
      series={[
        {
          data: lifeTimeEarnings.map(({ y, date }) => {
            return {
              y: Number(formatUnits(y, 'ether')),
              name: format(date, 'yyyy - MM - dd'),
            };
          }),
          color: mainPinkColor,
          label: t('Lifetime earning'),
        },
        {
          data: pendingEarnings.map(({ y, date }) => {
            return {
              y: Number(formatUnits(y, 'ether')),
              name: format(date, 'yyyy - MM - dd'),
            };
          }),
          color: buttonHoverColor,
          label: t('Pending earnings'),
        },
      ]}
      tooltipFormatter={({ y }) => {
        return `${numbro(y).format({
          thousandSeparated: true,
          mantissa: 3,
          trimMantissa: true,
        })} ${tokenName}`;
      }}
    />
  );
};
